// Module
var code = "<section class=\"status-section\">\n  <div class=\"status-table\">\n    <div class=\"status-row\" v-for=\"(value, key) in info\" :key=\"key\">\n      <div class=\"status-cell key\">{{ key }}</div>\n      <div class=\"status-cell value\">{{ value }}</div>\n    </div>\n  </div>\n</section>\n";
// Exports
export default code;